import { useEffect, useState } from 'react';
import './MiamiClock.scss';

// Miami is the canonical timezone for the entire Zona system. This clock
// shows operators the current Miami wall-clock so they're never confused
// about whether an event time / guestlist deadline they see in the panel
// is local or Miami — it's always Miami. Updates every 30s.
const formatMiami = () => {
  const time = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(new Date());
  return time;
};

function MiamiClock() {
  const [now, setNow] = useState(formatMiami);

  useEffect(() => {
    const tick = () => setNow(formatMiami());
    const id = setInterval(tick, 30000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="miami-clock" aria-label={`Current Miami time ${now} ET`}>
      <span className="miami-clock__time">{now}</span>
      <span className="miami-clock__label">ET</span>
    </div>
  );
}

export default MiamiClock;
